export default __webpack_public_path__ + "static/main-left-719cc2c2ef696d077d52b118245bb0f1.jpeg";